import React from "react";
import { ArticleExpertCard } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import { Category, DiscoverComponent } from "@/components/PageHome/api/interface";
import SectionHeader from "@/components/SectionHeader";
import routes from "@/helpers/router";
import { CategoryIconType } from "@/components/PageHome/interfaces";
import { DeviceInfo } from "@/interface/deviceInfo";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { NON_ONBOARDED_STATUS } from "@/helpers/constants";
import { getPlainTexts } from "@/helpers";
import styles from "./Discover.module.scss";

interface DiscoverProps {
  data: DiscoverComponent;
  userAgent: DeviceInfo;
  assetPosition: number;
}

const Discover: React.FC<DiscoverProps> = ({ data, userAgent, assetPosition }) => {
  const { Title, Description, Categories } = data;
  const router = useRouter();

  return (
    <section className={`${styles.root} spacingBetweenSections`}>
      <div className={"container"}>
        <SectionHeader title={Title} subTitle={Description} userAgent={userAgent} />
        {!!Categories?.length && (
          <div className={styles.contentBx}>
            {Categories.map((category: Category, index: number) => {
              const { Id, CategoryName, Slug, ShortDescription, ImageUrl } = category;
              const redirectUrl = routes.category(Slug);

              return (
                <div key={Id}>
                  <ArticleExpertCard
                    imageUrl={ImageUrl}
                    ctaText={"Find out more"}
                    ctaClick={() => {
                      assetClickedEvent({
                        asset_name: getPlainTexts(Title),
                        asset_display_text: CategoryName,
                        asset_position: assetPosition,
                        asset_element_position: index + 1,
                        momverse_stage: NON_ONBOARDED_STATUS,
                      });
                      router.push(redirectUrl);
                    }}
                    title={CategoryName}
                    redirectUrl={redirectUrl}
                    subTitle={ShortDescription}
                    isCircleIcon
                    iconType={CategoryIconType[CategoryName]}
                    isImageCover
                    className={styles.articleExpertCard}
                    bannerImageHeight="160px"
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Discover;
